import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from './client.js';
import type { CalendarEntry, MealSlot } from './calendarTypes.js';

export interface CreateCalendarEntryInput {
  date: string;
  meal_type: MealSlot;
  recipe_id: number;
  portions?: number;
}

export interface EntryIngredient {
  ingredient_id: number;
  name?: string;
  quantity: number;
  unit: string;
  is_override?: boolean;
}

export interface EntryIngredientsResponse {
  entry_id: number;
  ingredients: EntryIngredient[];
}

export function createCalendarEntry(
  input: CreateCalendarEntryInput,
): Promise<CalendarEntry> {
  return apiPost<CalendarEntry>('/api/calendar/entries', input);
}

export function deleteCalendarEntry(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/api/calendar/entries/${id}`);
}

export function updateCalendarEntryPortions(
  id: number,
  portions: number,
): Promise<CalendarEntry> {
  return apiPatch<CalendarEntry>(`/api/calendar/entries/${id}`, { portions });
}

export function getEntryIngredients(id: number): Promise<EntryIngredientsResponse> {
  return apiGet<EntryIngredientsResponse>(`/api/calendar/entries/${id}/ingredients`);
}

export function setEntryIngredients(
  id: number,
  ingredients: EntryIngredient[],
): Promise<EntryIngredientsResponse> {
  return apiPut<EntryIngredientsResponse>(
    `/api/calendar/entries/${id}/ingredients`,
    { ingredients },
  );
}

export function clearEntryIngredients(id: number): Promise<EntryIngredientsResponse> {
  return setEntryIngredients(id, []);
}
